import type { QueryClient } from '@tanstack/react-query';

export const CLOUD_EPISODES_QUERY_KEY = ['cloudEpisodes'] as const;
export const CLOUD_EPISODE_COUNT_QUERY_KEY = ['cloudEpisodeCount'] as const;
export const EPISODE_STATS_QUERY_KEY = ['episodeStats'] as const;

/** Only replace the list with an error state when no previously loaded result exists. */
export function isBlockingEpisodeCollectionError(
  isError: boolean,
  data: unknown,
): boolean {
  return isError && data === undefined;
}

/** Invalidate every collection-level view derived from episode rows. */
export async function invalidateEpisodeCollectionQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: CLOUD_EPISODES_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: CLOUD_EPISODE_COUNT_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: EPISODE_STATS_QUERY_KEY }),
  ]);
}
